import { useTranslation } from '@/i18n';
import { PassengerGenderOptions } from '@/types/passenger';
import { ProfileGenderOptions } from '@/types/profile';
import type { TFunction } from 'i18next';
import { useMemo } from 'react';

// Profile uses gender with `SEX.` prefix
// MALE = 'SEX.MALE',
// FEMALE = 'SEX.FEMALE',
// X = 'SEX.X',

// Passenger uses gender without `SEX.` prefix
// MALE = 'MALE',
// FEMALE = 'FEMALE',
// X = 'X',
export type GenderOptionsType = 'profile' | 'passenger';

export const getGenderOptions = (t: TFunction, type?: GenderOptionsType) => {
  if (type === 'passenger') {
    return [
      { value: PassengerGenderOptions.MALE, label: t('text.male') },
      { value: PassengerGenderOptions.FEMALE, label: t('text.female') },
      { value: PassengerGenderOptions.X, label: t('text.other') },
    ];
  }
  return [
    { value: ProfileGenderOptions.MALE, label: t('text.male') },
    { value: ProfileGenderOptions.FEMALE, label: t('text.female') },
    { value: ProfileGenderOptions.X, label: t('text.other') },
  ];
};

export const useGenderOptions = (type?: GenderOptionsType) => {
  const { t } = useTranslation();
  return useMemo(() => getGenderOptions(t, type), [t, type]);
};
